module.exports = __webpack_public_path__ + "img/F_image18.4ad44ce8.jpg";